import { DateFormatType } from "../services/altRedirect/types";

const formatMultiTypeDate = (date: string, format: DateFormatType): string => {
  const [year, month, day] = date.split("-");

  switch (format) {
    case "dd/mm/aaaa":
      return `${day}/${month}/${year}`;
    case "dd-mm-aaaa":
      return `${day}-${month}-${year}`;
    case "dd/mm/aa":
      return `${day}/${month}/${year.slice(2)}`;
    case "mm/dd/aaaa":
      return `${month}/${day}/${year}`;
    case "aaaa-mm-dd":
      return date;
    default:
      return date;
  }
};

export default formatMultiTypeDate;
